export default function IconCloseEye() {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="hidden">
        <g id="Layer 16">
          <path
            id="Vector"
            d="M419.721 419.716L92.261 92.2661L92.191 92.1861C90.4182 90.4277 88.3164 89.0357 86.0055 88.0896C83.6947 87.1435 81.2202 86.6618 78.7232 86.672C76.2263 86.6822 73.7558 87.1842 71.4528 88.1492C69.1498 89.1142 67.0594 90.5233 65.301 92.2961C63.5426 94.069 62.1506 96.1708 61.2045 98.4816C60.2584 100.792 59.7767 103.267 59.7869 105.764C59.8076 110.807 61.8306 115.635 65.411 119.186L94.081 147.856C59.3121 171.669 29.3847 201.871 5.89102 236.856C2.05452 242.521 0.00390625 249.205 0.00390625 256.046C0.00390625 262.887 2.05452 269.572 5.89102 275.236C65.861 363.996 160.931 415.996 256.001 415.346C286.796 415.458 317.385 410.331 346.461 400.186L392.871 446.596C396.447 450.056 401.237 451.976 406.213 451.942C411.189 451.908 415.953 449.924 419.481 446.415C423.01 442.906 425.021 438.153 425.082 433.178C425.144 428.202 423.251 423.401 419.811 419.806L419.721 419.716ZM256.001 363.736C237.989 363.729 220.266 359.209 204.451 350.587C188.637 341.966 175.235 329.518 165.471 314.382C155.707 299.246 149.892 281.905 148.557 263.942C147.223 245.979 150.411 227.969 157.831 211.556L187.781 241.506C185.369 252.874 185.835 264.665 189.137 275.807C192.44 286.949 198.474 297.089 206.691 305.306C214.908 313.524 225.049 319.558 236.191 322.86C247.333 326.162 259.123 326.629 270.491 324.216L300.441 354.166C286.482 360.496 271.328 363.759 256.001 363.736Z"
            fill="url(#paint0_linear_267_647)"
          ></path>
          <path
            id="Vector_2"
            d="M506.109 236.807C446.139 147.997 351.069 95.9966 255.999 96.6466C225.204 96.5351 194.615 101.662 165.539 111.807L211.539 157.807C231.5 148.773 253.74 146.038 275.295 149.965C296.849 153.892 316.695 164.295 332.188 179.788C347.68 195.28 358.083 215.126 362.01 236.681C365.938 258.236 363.202 280.476 354.169 300.437L417.909 364.177C452.684 340.368 482.615 310.165 506.109 275.177C509.943 269.513 511.993 262.831 511.993 255.992C511.993 249.152 509.943 242.47 506.109 236.807Z"
            fill="url(#paint1_linear_267_647)"
          ></path>
          <path
            id="Vector_3"
            d="M256.002 186.258C251.132 186.258 246.276 186.768 241.512 187.778L324.222 270.478C326.378 260.317 326.238 249.802 323.811 239.703C321.384 229.603 316.731 220.173 310.193 212.101C303.655 204.03 295.397 197.521 286.021 193.049C276.645 188.578 266.389 186.258 256.002 186.258Z"
            fill="url(#paint2_linear_267_647)"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_267_647"
          x1="55.2124"
          y1="87.5"
          x2="462.401"
          y2="390.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.278846" stopColor="var(--greenLight-color)"></stop>
          <stop offset="1" stopColor="var(--greenLight-color)"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_267_647"
          x1="210.536"
          y1="97.2472"
          x2="516.406"
          y2="350.741"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.278846" stopColor="var(--greenLight-color)"></stop>
          <stop offset="1" stopColor="var(--greenLight-color)"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_267_647"
          x1="252.451"
          y1="186.449"
          x2="341.436"
          y2="243.404"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.278846" stopColor="var(--greenLight-color)"></stop>
          <stop offset="1" stopColor="var(--greenLight-color)"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
